import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ProductFitIssueRate } from "@rtr/godmother";
import { listSerializationHelper } from "helpers/next-helpers";

const initialState = {
  pdp: {
    fitRatesLoaded: false,
    fitRates: null,
  },
};

export const fetchfitRates = createAsyncThunk("fitRates/fetchfitRates", async params => {
  try {
    const res = await ProductFitIssueRate.list({
      filter: {
        styleNames: params?.styleNames,
        fitRatePrimarySize: params?.primarySize,
        userId: params?.userId,
      },
    });

    if (!res || !Array.isArray(res)) {
      throw new Error("Unexpected response format");
    }

    const fitRates = listSerializationHelper(res)
      .filter(({ userSize }) => userSize === params?.primarySize)
      .map(({ size, canonicalSize, fitRate, numResponses, isRecommended, userSize, priority }) => ({
        size,
        fitRate,
        surveyCount: numResponses,
        isRecommended,
        canonicalSize,
        userSize,
        priority,
      }))
      .sort(({ canonicalSize: a }, { canonicalSize: b }) => parseInt(a, 10) - parseInt(b, 10));

    return fitRates;
  } catch (e) {
    if (window && window?.Sentry && window?.Sentry?.captureException) {
      window.Sentry.captureException(e, params);
    }
    return Promise.reject("Failed to retrieve fitRates");
  }
});

export const fitRatesSlice = createSlice({
  name: "fitRates",
  initialState,
  extraReducers: builder => {
    builder.addCase(fetchfitRates.fulfilled, (state, action) => {
      state.pdp = {
        ...state.pdp,
        fitRates: action.payload,
        fitRatesLoaded: true,
      };
    });
    builder.addCase(fetchfitRates.rejected, state => {
      state.pdp = {
        ...state.pdp,
        fitRates: null,
        fitRatesLoaded: true,
      };
    });
  },
});

/**
 * This value isn't used anywhere.
 * It's only defined because ReduxApp expects reducers to have a "types" property
 */
export const types = ["fitRates/fetchfitRates/fulfilled"];

export default {
  types: types,
  fn: fitRatesSlice.reducer,
};
